import { Data2, newId } from '../../../features/data-types'
import { useSystemStateHooks } from '../../system'
import { PaymentCategory, PaymentType } from '../state/types'

export const usePaymentTypeBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildPaymentType = (data: Data2) => {
        const {
            id = newId(),
            name,
            category,
            yield: _yield,
            financialCost,
            accreditationDays,
            cashFundIds,
            roundingEnabled,
            maxRoundingAmount,
            disabled,
            archived
        } = data
        const paymentType: PaymentType = {
            companyId: companyId!,
            id: id! as string,
            name: name! as string,
            category: category! as PaymentCategory,
            yield: _yield! as number,
            financialCost: financialCost! as number,
            accreditationDays: (accreditationDays || 0) as number,
            cashFundIds: (cashFundIds || []) as string[],
            roundingEnabled: !!roundingEnabled,
            maxRoundingAmount: roundingEnabled ? (maxRoundingAmount as number) : undefined,
            disabled: !!disabled,
            archived: !!archived
        }

        return paymentType
    }

    return {
        buildPaymentType
    }
}
